module.exports = __webpack_public_path__ + "static/media/f_eyeshape_almond_grey.62fddf18.png";